import placeholderUrl from '@assets/images/placeholder.png';
import { HawkSearchComponents, HawkSearchGlobal, RecommendationsItem, RecommendationsItemComponentConfig, RecommendationsItemComponentModel } from '@models';
import { trackingService } from '@services';
import { BaseComponent } from '../../base.component';
import defaultHtml from './recommendations-item.component.hbs';

declare let HawkSearch: HawkSearchGlobal;

export class RecommendationsItemComponent extends BaseComponent<RecommendationsItemComponentConfig, RecommendationsItem, RecommendationsItemComponentModel> {
    protected override componentName: keyof HawkSearchComponents = 'recommendations-item';
    protected override defaultHtml = defaultHtml;
    protected override bindFromEvent = false;

    private get widgetId(): string | undefined {
        return this.getAttribute('widget-id') || undefined;
    }

    private get requestId(): string | undefined {
        return this.getAttribute('request-id') || undefined;
    }

    protected override renderContent(): boolean {
        return !!this.data;
    }

    protected override getContentModel(): RecommendationsItemComponentModel {
        return {
            ...this.data!,
            strings: {
                sale: this.configuration?.strings?.sale ?? 'Sale'
            }
        };
    }

    protected bindChildElements(): void {
        this.rootElement.querySelectorAll('[hawksearch-image]').forEach((e) => {
            e.addEventListener('error', (event: Event): void => {
                const element = event.currentTarget as HTMLImageElement;

                element.src = HawkSearch.config.placeholderImageUrl || placeholderUrl;
            });
        });

        this.rootElement.querySelectorAll('[hawksearch-link]').forEach((e) => {
            e.addEventListener('click', ((event: PointerEvent): void => {
                if (!this.data || !this.widgetId || !this.requestId) {
                    return;
                }

                trackingService.trackRecommendationClick(this.widgetId, this.requestId, this.data.id);
            }) as EventListener);
        });
    }
}
